export default __webpack_public_path__ + "static/media/beispiel-versicherungsausweis.0d812796.png";